import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { KanbanBoardStatus } from 'views/pages/dashboard/KanbanQuestions/constants';
const InfiniteScrollComponent = ({
    children,
    pullDownToRefreshThreshold,
    hasMore,
    endMessage,
    loader,
    dataLength,
    fetchData,
    scrollableTarget,
    loading,
    id,
    columnId
    //innerRefKey
}) => {
    const [scrollShow, setScrollShow] = useState(false);
    useEffect(() => {
        const element = document.getElementById(`scrollableDiv${columnId}`);
        if (!element) return;

        const checkForScrollbar = () => {
            const scrollComponentOuter = element.querySelector('.infinite-scroll-component__outerdiv');
            const scrollComponentNext = element.querySelector('.customInfiniteScroll > div');

            if (scrollComponentOuter.clientHeight >= scrollComponentNext.clientHeight) {
                document.getElementById(`scrollableDiv${columnId}`).classList.remove('has-scrollbar');
                setScrollShow(false);
            } else {
                document.getElementById(`scrollableDiv${columnId}`).classList.add('has-scrollbar');
                setScrollShow(true);
            }
        };

        checkForScrollbar();

        // Add resize listener to re-check on window resize
        window.addEventListener('resize', checkForScrollbar);

        // Cleanup listener on component unmount
        return () => window.removeEventListener('resize', checkForScrollbar);
    }, [columnId, dataLength]);
    return (
        <>
            <InfiniteScroll
                id={id}
                dataLength={dataLength} //This is important field to render the next data
                next={fetchData}
                hasMore={hasMore}
                height={'auto'}
                style={{
                    maxHeight: '68vh',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    width: 'calc(100% + 7px)',
                    // width: '100%'
                    height: scrollShow ? 'auto' : '100%',
                    minHeight: dataLength > 0 ? '100%' : '0'
                }}
                loader={loading ? !loader : ''}
                endMessage={endMessage || ''}
                scrollableTarget={scrollableTarget || ''}
                className={`customInfiniteScroll`}
                pullDownToRefreshThreshold={pullDownToRefreshThreshold}
                // ref={innerRefKey}
            >
                {children || ''}
            </InfiniteScroll>
        </>
    );
};
export default InfiniteScrollComponent;
